<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>
<div class="card-body-tab">
    <div class="col-12 px-2">
        <div class="cards-body">
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm table-responsive-md table-responsive-lg"
                    style="overflow-x: auto;">
                    <table id="example1" class="table card-layout table-striped table">

                        <thead>
                            <tr id="main_row_headingId">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div class="header-color cursorPointer header_title">
                                            Trip ID
                                        </div>
                                        <div class="header-color cursorPointer header_title"
                                            (click)="sortBy='requestedBy'; sortOrder = !sortOrder;
                                            invoiceStatusReportSorting.requestedBy = !invoiceStatusReportSorting.requestedBy;">
                                            Requested By
                                            <i *ngIf="invoiceStatusReportSorting.requestedBy"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!invoiceStatusReportSorting.requestedBy"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer header_title"
                                            (click)="sortBy='requestedOn'; sortOrder = !sortOrder;
                                            invoiceStatusReportSorting.requestedOn = !invoiceStatusReportSorting.requestedOn;">
                                            Requested On
                                            <i *ngIf="invoiceStatusReportSorting.requestedOn"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!invoiceStatusReportSorting.requestedOn"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer header_title"
                                            (click)="sortBy='invoiceStatus'; sortOrder = !sortOrder;
                                            invoiceStatusReportSorting.invoiceStatus = !invoiceStatusReportSorting.invoiceStatus;">
                                            Invoice Status
                                            <i *ngIf="invoiceStatusReportSorting.invoiceStatus"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!invoiceStatusReportSorting.invoiceStatus"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer header_title">
                                            Failure Reason
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                *ngFor="let record of invoiceStatusReportData?.data
                                |orderBy: sortBy:sortOrder | filter: searchText
                                | paginate: {id:'invoiceStatusPagination',itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: invoiceStatusReportData?.totalRecords};">
                                <td>
                                    <div class="row_container" id="main_row_id">

                                        <div class="title_container">
                                            <div class="row_title">Trip ID</div>
                                            <div class="row_detail cursorPointer"
                                                *ngFor="let tripData of record.tripDetails">
                                                <a
                                                    href="{{itineraryPageRedirectUrl}}/{{tripData.serviceRequestId}}/Report">
                                                    {{tripData.tripId}}
                                                </a>
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Requested By</div>
                                            <div class="row_detail">
                                                {{record.requestedBy}}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Requested On</div>
                                            <div class="row_detail cursorPointer">
                                                {{record.requestedOn | localDate : timeZone}}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Invoice Status</div>
                                            <div class="row_detail">
                                                {{ record.invoiceStatus ? record.invoiceStatus : 'N/A' }}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Failure Reason</div>
                                            <div class="row_detail">
                                                {{ record.invoiceFailureReason ? record.invoiceFailureReason : '' }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        <tbody>
                    </table>
                </div>
                <div *ngIf="invoiceStatusReportData?.totalRecords==0" style="color: #a82b41" class="mt-2">
                    <b>No Records Found</b>
                </div>
                <div class="col-md-12 p-0 paginationAlingment" style="margin-top: 10px ; "
                    *ngIf="invoiceStatusReportData?.totalRecords > 0">
                    <div class="col-md-6 p-0">
                        {{ paginationText }}
                    </div>
                    <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls [maxSize]="6" [previousLabel]="''" [nextLabel]="''"
                            [responsive]="responsive" (pageChange)="currentPage = $event;updatePaginationText(true)"
                            id="invoiceStatusPagination">
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>